/* eslint-disable no-undef */
(function patchResizeObserver() {
  if (typeof window === 'undefined' || !('ResizeObserver' in window)) return;

  const OriginalRO = window.ResizeObserver;

  // double-rAF defers the callback to avoid the RO loop warning
  const doubleRaf = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  window.ResizeObserver = class ResizeObserverPatched {
    constructor(cb) {
      const wrapped = (entries, observer) => {
        doubleRaf(() => {
          try {
            cb(entries, observer);
          } catch (e) {
            // don't re-enter the RO loop with thrown errors
            setTimeout(() => { throw e; }, 0);
          }
        });
      };
      this._ro = new OriginalRO(wrapped);
    }
    observe(...args)    { return this._ro.observe(...args); }
    unobserve(...args)  { return this._ro.unobserve(...args); }
    disconnect(...args) { return this._ro.disconnect(...args); }
    takeRecords(...args) {
      return typeof this._ro.takeRecords === 'function'
        ? this._ro.takeRecords(...args)
        : [];
    }
  };
})();
